<page-content [label]="'Homepage' | translate" contentMargin="0" contentClass="homepage-top-level-styling">

    <ng-container class="homepage-content" content>

        <section>

            <header class="homepage-header">

                <h1 class="homepage-title">
                    Benvenuto<span *ngIf="userDisplayName">, {{ userDisplayName }}</span>
                </h1>

                <div class="homepage-date">

                    <span *ngIf="formattedDate">
                        {{ formattedDate }}
                    </span>

                    <ng-container *ngIf="structureName">

                        <span class="homepage-date-separator">·</span>

                        <span class="homepage-structure-name">
                            {{ structureName | uppercase }}
                        </span>

                    </ng-container>

                </div>

            </header>

            <div class="homepage-button-grid">

                <div *ngFor="let button of buttons" class="homepage-button"
                    [style.--card-accent]="button.buttonColor?.color1 || '#64748b'"
                    [style.--card-background]="getButtonBackground(button.buttonColor?.color1)"
                    (click)="switchTo(button.url, button.newTab)">

                    <div class="homepage-button-square">

                        <div class="homepage-button-copy">
                            <span class="homepage-button-label">
                                {{ button.label }}
                            </span>

                            <span *ngIf="button.description" class="homepage-button-subtitle">
                                {{ button.description }}
                            </span>
                        </div>

                        <div *ngIf="button.buttonIcon" class="homepage-button-icon-container">

                            <span class="homepage-button-icon"
                                [style.--icon-url]="'url(&quot;assets/button-icons/' + button.buttonIcon.filename + '.png&quot;)'">
                            </span>

                        </div>

                    </div>

                </div>

            </div>

        </section>

    </ng-container>
</page-content>